import PaddedLayout from 'layout/MainLayout/PaddedLayout';

import ListCreateButton from 'components/buttons/ListCreateButton';
import PageHeader from 'components/PageHeader';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import JobRolesTableWithFilters from './JobRolesTable';

type Props = Record<string, never>; // Empty props

const JobRolesListPage: React.FC<Props> = () => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'job-roles.job-roles'}
                    showBreadcrumb
                    buttons={
                        <ListCreateButton
                            permissions={['CREATE.JOB_ROLES']}
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => navigateWithReturn(`/job-role/new`)}
                            labelId="job-roles.add-new-job-role"
                            newLabelId="new-entity.job-role"
                        />
                    }
                />
                <JobRolesTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default JobRolesListPage;
